// First Created - 11 Aug 2025
// Author - Atul Pandey

import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '@/app/api/apiSlice'

const goalTypesAdapter = createEntityAdapter({})

const initialState = goalTypesAdapter.getInitialState()

export const goalTypesApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getGoalTypes: builder.query({
            query: () => ({
                url: '/goalTypes/getGoalTypes',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loadedGoalTypes = responseData.map(goalType => {
                    goalType.id = goalType._id
                    return goalType
                })
                return goalTypesAdapter.setAll(initialState, loadedGoalTypes)
            },
            providesTags: (result, error, arg) => {
                if(result?.ids) {
                    return [
                        {type: 'GoalType', id: 'LIST'},
                        ...result.ids.map(id => ({ type: 'GoalType', id}))
                    ]
                } else {
                    return [ { type: 'GoalType', id: 'LIST'}]
                }
            },
        }),
        createNewGoalType: builder.mutation({
            query: initialGoalType => ({
                url: '/goalTypes/createNewGoalType',
                method: 'POST',
                body: {...initialGoalType,}
            }),
            invalidatesTags: [
                { type: 'GoalType', id: "LIST" }
            ] 
        }),
        updateGoalType: builder.mutation({
            query: initialGoalType => ({
                url: '/goalTypes/updateGoalType',
                method: 'PATCH',
                body: {...initialGoalType,}
            }),
            invalidatesTags: (result, error, arg) => [
                {type: 'GoalType', id: arg.id },
                { type: 'GoalType', id: 'LIST' }
            ],
        }),
        deleteGoalType: builder.mutation({
            query: ({id}) => ({
                url: '/goalTypes/deleteGoalType',
                method: 'DELETE',
                body: {id}
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'GoalType', id: arg.id}
            ]
        }),
    }),
})

export const {
    useGetGoalTypesQuery,
    useCreateNewGoalTypeMutation,
    useUpdateGoalTypeMutation,
    useDeleteGoalTypeMutation,
} = goalTypesApiSlice

// returns the query result object
export const selectGoalTypeResult = goalTypesApiSlice.endpoints.getGoalTypes.select()

// create memoized selector
const selectGoalTypesData = createSelector(
    selectGoalTypeResult,
    goalTypeResult => goalTypeResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllGoalTypes,
    selectById: selectGoalTypeById,
    selectIds: selectGoalTypeIds,
} = goalTypesAdapter.getSelectors(state => selectGoalTypesData(state) ?? initialState)